<template>
    <div class="test-item">
        <div class="question">{{index+1}}、{{ test.question }}</div>
        <div class="radio-option">
            <div :class="chocieIndex==i ? 'option-item-ac':'option-item'" v-for="(t, i) in test.level" :key="i" @click="choice(i)">
                <div class="option-text">{{optionText[i]}}.{{ t.content }}</div>
                <div :class="chocieIndex==i ? 'option-icn-ac':'option-icn'"></div>
            </div>
            <!-- <div class="option-item-ac">
                <div class="option-text">A . 没有</div>
                <div class="option-icn-ac"></div>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    props:['test','index','id'],
    data() {
        return {
            optionText:['A','B','C','D','E','F','G','H','I'],
            chocieIndex:null,
        };
    },
    computed: {},
    methods: {
        choice(num){
            this.chocieIndex=num;
            this.$emit('choice-radio', {id:this.id,ans:this.test.level[num].content,score:this.test.level[num].score})
        }
    },
    created() {

    },
};
</script>
<style lang='less' scoped>
.test-item {
    padding: 12px;
    border-radius: 10px;
    background-color: #fff;
}
.question {
    line-height: 34px;
    font-size: 18px;
    color: #333;
    color: #333;
}
.option-item {
    height: 50px;
    padding: 0px 15px;
    border-radius: 10px;
    background-color: #fbfcfc;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}
.option-item-ac {
    height: 50px;
    padding: 0px 15px;
    border-radius: 10px;
    background-color: #e5f9f9;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}
.option-text {
    line-height: 50px;
    font-size: 14px;
    color: #333;
}
.option-icn {
    height: 14px;
    width: 14px;
    border-radius: 50%;
    border: 1px solid #c5caca;
    margin-top: 17px;
}
.option-icn-ac {
    height: 12px;
    width: 12px;
    border-radius: 50%;
    border: 2px solid #01d6d6;
    margin-top: 17px;
}
</style>